import { MessageCircle, Bell, Users, Zap } from "lucide-react";
import { SectionHead } from "./Home";

const WHATSAPP_URL =
  process.env.REACT_APP_WHATSAPP_URL ||
  "https://chat.whatsapp.com/PULLSTATION-INVITE"; // sostituisci con il tuo invite ufficiale

export default function Community() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-12 md:py-20">
      <SectionHead
        eyebrow="Community"
        title="La community WhatsApp di PULL STATION"
        subtitle="Un unico gruppo dove riceverai tutti gli aggiornamenti che contano — senza spam, senza rumore."
        icon={<MessageCircle size={16} />}
      />

      <div className="mt-10 border border-[#C9A227]/25 bg-[#0b0b0d] rounded-sm relative overflow-hidden">
        <div className="absolute inset-0 hero-grid opacity-20 pointer-events-none" />
        <div className="relative p-8 md:p-12">
          <div className="grid md:grid-cols-3 gap-6">
            <Feature
              icon={<Bell size={18} />}
              title="Anteprima drop"
              desc="I nuovi preorder e i drop giapponesi sono comunicati in anteprima nel gruppo WhatsApp."
            />
            <Feature
              icon={<Zap size={18} />}
              title="Restock & occasioni"
              desc="Restock lampo, sconti riservati e prodotti esclusivi disponibili in quantità limitata."
            />
            <Feature
              icon={<Users size={18} />}
              title="Aggiornamenti ordini"
              desc="Comunicazioni dirette su allocazioni EN, arrivi giapponesi e stato delle spedizioni."
            />
          </div>

          <div className="gold-hairline my-10" />

          <div className="text-center">
            <h3 className="font-display text-2xl md:text-3xl font-extrabold text-white">
              Un solo tap e sei dentro.
            </h3>
            <p className="text-[#9CA3AF] mt-2 max-w-xl mx-auto text-sm">
              Clicca il pulsante qui sotto per entrare nel gruppo WhatsApp ufficiale PULL STATION.
              Puoi uscire quando vuoi, nessun impegno.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-join-page"
              className="btn-gold mt-6 text-base"
            >
              <MessageCircle size={18} /> Entra nel gruppo WhatsApp
            </a>
            <p className="text-[10px] font-mono-ps text-[#6B7280] tracking-widest uppercase mt-4">
              Nessun costo • Privacy rispettata • Solo aggiornamenti utili
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const Feature = ({ icon, title, desc }) => (
  <div className="border border-[#C9A227]/15 rounded-sm p-5 bg-[#121214]">
    <div className="flex items-center gap-2 text-[#C9A227]">
      {icon}
      <span className="text-xs font-mono-ps uppercase tracking-widest">{title}</span>
    </div>
    <p className="text-sm text-[#D1D5DB] mt-3 leading-relaxed">{desc}</p>
  </div>
);
